import { defineComponent as _defineComponent } from 'vue'
import { EffectFade, Autoplay, Navigation } from 'swiper'


export default /*@__PURE__*/_defineComponent({
  __name: 'SpeakerFade',
  props: {
  loop: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const modules = [EffectFade, Autoplay, Navigation]

const __returned__ = { props, modules, get EffectFade() { return EffectFade }, get Autoplay() { return Autoplay }, get Navigation() { return Navigation } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})